import { render, staticRenderFns } from "./channelDialogContent.vue?vue&type=template&id=0d824be0&scoped=true"
import script from "./channelDialogContent.vue?vue&type=script&lang=js"
export * from "./channelDialogContent.vue?vue&type=script&lang=js"
import style0 from "./channelDialogContent.vue?vue&type=style&index=0&id=0d824be0&prod&lang=scss&scoped=true"
import style1 from "./channelDialogContent.vue?vue&type=style&index=1&id=0d824be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d824be0",
  null
  
)

export default component.exports